import { UseMutationOptions } from '@tanstack/react-query';
import useMutation from 'hooks/useMutation';
import { ApiMethods, CuredApiPaths } from 'models/enums';
import MutationKeys from './keys';
import { PathWithID } from 'models/types';
import { CommunicationType } from 'domains/content/types';

export type UpdateDirectMailInput = {
    applicationsAccess: string;
    communicationType: CommunicationType;
    id: string;
    name: string;
    html: string;
    design: any; // TODO: use real type from unlayer
};

const useUpdateDirectMail = (id: string, mutateOptions: UseMutationOptions<unknown, Error, UpdateDirectMailInput>) =>
    useMutation<UpdateDirectMailInput>(
        MutationKeys.UPDATE_DIRECT_MAIL,
        new PathWithID(CuredApiPaths.DIRECT_MAIL, Number(id)),
        mutateOptions,
        ApiMethods.PUT
    );

export default useUpdateDirectMail;
